const Forms =
    [
        {
            type: 'Select',
            options: 'Estatus',
            label: 'status',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'Status',
            id: 'Status',
            datatype: 'select',
            show: true,
            style: { fontWeight: 'bold', fontSize: '12px' },
        },
        {
            type: 'Select',
            options: 'Customers',
            label: 'company',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'CustomerName',
            id: 'CustomerName',
            datatype: 'select',
            show: true,
            style: { fontWeight: 'bold', fontSize: '12px' },

        },
        {
            type: 'Select',
            options: 'Suppliers',
            label: 'shipper',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'SupplierName',
            id: 'SupplierName',
            datatype: 'select',
            show: true,
            style: { fontWeight: 'bold', fontSize: '12px' },

        }, {
            type: 'Select',
            options: 'Consignees',
            label: 'consignee',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'ConsigneeName',
            id: 'ConsigneeName',
            datatype: 'select',
            show: true,
            style: { fontWeight: 'bold', fontSize: '12px' },
        },
        {
            type: 'Select',
            options: 'TransportModes',
            label: 'transport_mode',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'TransportMode',
            id: 'TransportMode',
            datatype: 'select',
            show: true,
            style: { fontWeight: 'bold', fontSize: '12px' },
        },
        {
            type: 'Datetime',
            label: 'creation_date',
            name: 'SOCreationDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'SOCreationDate',
            style: { fontWeight: 'bold', fontSize: '12px' },
        },
        {
            type: 'Datetime',
            label: 'cargo_ready_commitment_date',
            name: 'PromiseCargoReadyDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'PromiseCargoReadyDate',
            style: { fontWeight: 'bold', maxWidth: "60%", fontSize: '12px' },
        },
        {
            type: 'Datetime',
            label: 'cargo_ready_est',
            name: 'EstCargoReadyDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'EstCargoReadyDate',
            style: { fontWeight: 'bold', fontSize: '12px' },
        },
        {
            type: 'Datetime',
            label: 'actual_cargo_ready',
            name: 'ActualCargoReadyDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'ActualCargoReadyDate',
            style: { fontWeight: 'bold', fontSize: '12px' },
        },
        {
            type: 'Datetime',
            label: 'required_at_destination',
            name: 'RequiredDateDestination',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'RequiredDateDestination',
            style: { fontWeight: 'bold', fontSize: '12px' },
        }
        ,
        {
            type: 'Datetime',
            label: 'arrive_at_final_destination',
            name: 'FinalDestinationArrivalDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'FinalDestinationArrivalDate',
            style: { fontWeight: 'bold', fontSize: '12px' },
        }
    ]

export default Forms